import { type ReactNode } from 'react';
import { TooltipProvider as RadixTooltipProvider } from '@/shared/components/ui';

interface TooltipProviderProps {
  children: ReactNode;
}

export function TooltipProvider({ children }: TooltipProviderProps) {
  return (
    <RadixTooltipProvider delayDuration={0} skipDelayDuration={300}>
      {children}
    </RadixTooltipProvider>
  );
}
